import { useState } from 'react'
import SelectBundle from '../ui/select-bundle'
import selectStyle from '../const/select'
import SearchSvg from '../assets/img/svg/search'
import strEmpty from '../utils/strEmpty'

const NavBarWebhooks = ({ searchParams, setSearchParams }) => {
  const filter = searchParams.get('filter')
  const search = searchParams.get('search')
  const [webhook, setWebhook] = useState(filter || 'all')
  const optWebhookFilter = [
    { value: 'all', label: 'All webhooks' },
    { value: 'active', label: 'Active' },
    { value: 'deleted', label: 'Deleted' },
  ]

  return (
    <div className="nav-bar">
      <SelectBundle
        value={webhook || filter}
        callback={(e) => {
          setWebhook(e.value)
          searchParams.set('filter', e.value)
          setSearchParams(searchParams)
        }}
        style={selectStyle}
        opt={optWebhookFilter}
        placeholder={'All webhooks'}
      />
      <div className="nav-bar-search">
        <input
          placeholder="Search"
          value={search || ''}
          onChange={(e) => {
            if (strEmpty(e.target.value)) {
              searchParams.delete('search')
              setSearchParams(searchParams)
            } else {
              searchParams.set('search', e.target.value)
              setSearchParams(searchParams)
            }
          }}
        />
        <SearchSvg />
      </div>
    </div>
  )
}

export default NavBarWebhooks
